<!--
 * @Author: zb
 * @LastEditors: Do not edit
 * @Date: 2019-08-08 19:37:56
 * @LastEditTime: 2019-08-09 09:29:48
 * @Version: 1.0
 * @Description: 个人中心中展示货源详情的页面
 * @Company: 济南广域软件
 * @Copyright: Copyright (c) Jnwat Soft
 * @Remarks: 备注
 -->

<template>
  <div class="goods-item-details">
    <div class="base-info">
      <div>基本信息</div>
      <ul>
        <li>
          <div style="color: rgb(92,162,62)">
            <span>起运地</span>
            {{ goods.startPlaceProvince + goods.startPlaceLabel }}
          </div>
          <div>
            <span>详细地址</span>
            {{ goods.startPlaceDetail }}
          </div>
        </li>
        <li>
          <div style="color: rgb(196,56,62)">
            <span>目的地</span>
            {{ goods.stopPlaceProvince + goods.stopPlaceLabel }}
          </div>
          <div>
            <span>详细地址</span>
            {{ goods.stopPlaceDetail }}
          </div>
        </li>
        <li>
          <div>
            <span>公司名称</span>
            {{ goods.companyName }}
          </div>
          <div>
            <span>货物名称</span>
            {{ goods.goodsName }}
          </div>
          <div>
            <span>货品重量</span>
            {{ goods.weight }}吨
          </div>
        </li>
        <li>
          <div>
            <span>理化性质</span>
            {{ goods.physicalPropertyLabel }}
          </div>
          <div>
            <span>包装类型</span>
            {{ goods.packageTypeLabel }}
          </div>
          <div>
            <span>运输方式</span>
            {{ goods.transportTypeLabel }}
          </div>
        </li>
        <li>
          <!--<div>-->
            <!--<span>货物体积</span>-->
            <!--{{ goods.capacity }}m³-->
          <!--</div>-->
          <div>
            <span>付款方式</span>
            {{ goods.payTypeLabel }}
          </div>
        </li>
      </ul>
    </div>
    <div class="contact-info">
      <div>联系人</div>
      <ul>
        <li>
          <span>联系人</span>
          {{ goods.contacter }}
        </li>
        <li>
          <span>联系电话</span>
          {{ goods.contacterTel | safePhone }}
        </li>
      </ul>
    </div>
    <div class="imgs-info">
      <div>图片</div>
      <ul>
        <li v-for="(url, index) of goods.fileUrl" :key="index">
          <div  v-viewer>
            <img :src="url|getImg" lazy  @onerror="imgsrc(this)">
          </div>
  <!--        <div v-else v-viewer>
 <el-image class="infoImg" :src="require('@/assets/img/default_img.png')" lazy onerror="this.src='https://graph.baidu.com/thumb/v3/3277128572,4129418819.jpg';this.onerror=null;" />
          </div> -->
        </li>

      </ul>
    </div>
    <div>
      <div>备注</div>
      <span>{{ goods.remarks }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'GoodsFullInfo',
  props: {
    goods: {
      type: Object,
      default: () => {
        return {}
      }
    },
    area: {
      type: Array,
      default: () => {
        return []
      }
    }

  },
  methods:{
    cargoUrl(demand) { // 图片回调
    console.log("demand:"+demand)
      return (demand) => {
        if (demand == null || demand == '') {
          return false
        }
        return demand.split(',').filter(n => n) // 数组去空
      }
    },
    imgsrc(sr){
      console.log(this)
      this.src=require('@/assets/img/default_img.png');
      //  console.log("imgsrc:"+this.src)
      this.onerror=null;
    }
  }
}
</script>

<style lang="scss" scoped>
$perfix: "goods-item";
$main-color: rgb(190, 35, 22);
@keyframes show {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.#{$perfix}-details {
  position: relative;
  width: 100%;
  background-color: rgb(250, 251, 255);
  transition: all 0.8s ease-in-out;
  z-index: -1;
  padding-bottom: 16px;
  display: block;
  animation: show 0.8s ease-in-out;
  clip: rect(0 auto 0 0);
  > div {
    padding: 16px 16px;
    width: calc(100% - 32px);
    font-size: 14px;
    border-bottom: 1px solid #ebeef5;
    &:last-child {
      border-bottom: none !important;
    }

    ul {
      li {
        span:after {
          content: " : ";
        }
      }
    }

    > div {
      font-size: 15px;
      font-weight: bold;
      color: $main-color;
      margin-bottom: 24px;
    }
    &.base-info {
      ul {
        > li {
          min-height: 45px;
          font-size: 15px;
          font-weight: 400;
          line-height: 15px;
          padding: 15px 0px;
          // white-space: nowrap;
          // display: flex;
          // justify-content: flex-start;
          box-sizing: border-box;
          color: #333;
          > div {
            // text-overflow: ellipsis;
            // overflow: hidden;
            display: inline-block;
            &:first-child {
              // flex: 0 1 343px;
              width: 343px;
            }
            //  &:nth-child(2) {
            //   // flex: 0 1 343px;
            //   width: 343px;
            // }
          }

          &:nth-child(3),
          &:nth-child(4) {
            > div {
              &:nth-child(2) {
                text-overflow: ellipsis;
                overflow: hidden;
                flex: 0 1 285px;
                width: 285px;
              }
              &:last-child {
                display: inline;
                // width: 100%;
                // text-indent: (285px + 343px);
                // position: absolute;
                // text-overflow: ellipsis;
                // overflow: hidden;
                // flex: 0 1 285px;
                // width: 248px;
              }
            }
          }
        }
      }
    }
    &.contact-info {
      ul {
        width: 100%;
        display: flex;
        // columns: 2;
        // column-width: 25%;
        // column-gap: 16px;
        > li {
          height: 16px;
          line-height: 16px;
          padding: 4px 0px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          &:first-child {
            width: 343px;
          }
        }
      }
    }

    &.imgs-info {
      ul {
        display: inline-block;
        li {
          float: left;
          margin-right: 24px;
          margin-bottom: 12px;
          &:last-child {
            margin-right: 0px !important;
          }
          img {
            height: 124px;
            width: 136px;
            justify-content: s;
          }
        }
      }
    }
  }
}
</style>
